import type { LocationQueryValue } from 'vue-router';
import { decodeBase64Json } from '~~/helpers/dataStructure/decodeBase64Json';

export interface VoucherPayload {
  voucher_code: string;
}

export function encodeVoucherPayload(payload: VoucherPayload): string {

  try {

    const json = JSON.stringify(payload);

    return Buffer.from(json, 'utf8').toString('base64');

  } catch {

    return '';

  }

}

export function decodeVoucherPayload(
  encoded: LocationQueryValue | LocationQueryValue[] | undefined,
): VoucherPayload | null {

  if (!encoded) {

    return null;

  }

  const value = Array.isArray(encoded) ? encoded[0] : encoded;

  if (typeof value !== 'string' || value.length === 0) {

    return null;

  }

  const obj = decodeBase64Json<Record<string, unknown>>(value);

  if (obj && typeof obj === 'object' && 'voucher_code' in obj) {

    return { voucher_code: obj.voucher_code as string };

  }

  return null;

}
